// extracted by mini-css-extract-plugin
export default {"stickyFooter":"styles_stickyFooter__7d8P1"};